import * as React from "react";
import type { SVGProps } from "react";
const SvgDiamond = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m18.86 4.49 3 5v.01c.23.37.18.85-.11 1.18l-8.5 9.5c-.35.35-.78.54-1.23.54H12c-.45 0-.87-.18-1.19-.49l-8.56-9.56a.994.994 0 0 1-.11-1.18l3-5A.99.99 0 0 1 6 4h12c.35 0 .68.19.86.49ZM4.24 9.88 12 18.56h.01l7.76-8.68L17.44 6H6.57L4.24 9.88Zm5.22-.56-.22.36.01.01 1.5 1.65c.37.41.34 1.04-.07 1.41a.996.996 0 0 1-1.41-.07l-2-2.2a.996.996 0 0 1-.12-1.19l.6-1c.28-.47.9-.62 1.37-.34.47.28.62.9.34 1.37Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDiamond;
